// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";

import { isTimeSeries } from "../appsAppGroupIdChartsSessions";

export const isAppsAppGroupIdChartsSessionsPreviousWindowResult = objectOf({
  daily_dau: isTimeSeries,
  daily_mau: isTimeSeries,
  daily_new_users: isTimeSeries,
  daily_sessions: isTimeSeries,
});
